module.exports = __webpack_public_path__ + "static/media/ChatApp-pic-R.658c5776.PNG";